export const clean = (number: string) => {
  return number.toString().replace(/[^\d^+]/gm, '');
};

const invalidAreaCodeLeadDigits = ['0', '1'];

export const stripInvalidLeadingDigit = (value: string): string => {
  if (!value) {
    return value;
  }
  let result = value;
  let match = result.match(/\d/);
  while (match && invalidAreaCodeLeadDigits.includes(match[0])) {
    const index = match.index as number;
    result = result.slice(0, index) + result.slice(index + 1);
    match = result.match(/\d/);
  }
  return result;
};

export const mask = (): ((rawValue: string) => (string | RegExp)[]) => () =>
  ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
